/**
 * Per-account role values. Super-admin is a separate boolean on the user
 * record, not a Member.role value, so a user can be SuperAdmin globally and
 * still have a regular per-account role inside Better Auth's organization.
 */
export const Role = {
  ACCOUNT_ADMIN: 'ACCOUNT_ADMIN',
  ACCOUNT_EDITOR: 'ACCOUNT_EDITOR',
  ACCOUNT_VIEWER: 'ACCOUNT_VIEWER',
} as const;

export type Role = (typeof Role)[keyof typeof Role];

export const ROLE_VALUES: readonly Role[] = Object.values(Role);

export function isRole(value: unknown): value is Role {
  return typeof value === 'string' && (ROLE_VALUES as readonly string[]).includes(value);
}
